// 前端页面
const home = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/error',
    name: 'home_error',
    component: () => import('@/components/home/error/index.vue')
  },

  {
    path: '/index',
    component: () => import('@/layouts/home/common.vue'),
    children: [
      {
        path: '/index',
        name: 'index',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('../components/home/index/index.vue')
      },
      {
        path: '/select',
        name: 'select',
        meta: {
          title: '选择栏目',
          auth: false
        },
        component: () => import('../components/home/index/select.vue')
      },
      {
        path: '/question',
        name: 'question',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('../components/home/index/question.vue')
      },
      {
        path: '/success',
        name: 'success',
        meta: {
          title: '提交成功',
          auth: false
        },
        component: () => import('../components/home/index/success.vue')
      },

    ]
  }
]

const system = [
  {
    path: '/system',
    name: 'system',
    meta: {
      title: '后台系统'
    },
    component: () => import('@/layouts/system/index.vue'),
    children: [
      {
        path: '/system',
        name: 'system_index',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('@/components/system/index/index')
      },
      {
        path: '/system/index',
        name: 'system_index',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('@/components/system/index/index')
      },
      {
        path: '/system/user/index',
        name: 'system_user_index',
        meta: {
          title: '个人设置',
          auth: true
        },
        component: () => import('@/components/system/setting/user/index')
      },
      {
        path: '/system/role/index',
        name: 'system_role_index',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/components/system/setting/role/index')
      },
      {
        path: '/system/role/permissions',
        name: 'system_role_permissions',
        meta: {
          title: '权限配置'
        },
        component: () => import('@/components/system/setting/role/permissions')
      },
      {
        path: '/system/role/seting',
        name: 'system_role_seting',
        meta: {
          title: '角色设置'
        },
        component: () => import('@/components/system/setting/role/seting')
      },

      {
        path: '/system/admin/index',
        name: 'system_admin_index',
        meta: {
          title: '账号管理',
          auth: true
        },
        component: () => import('@/components/system/setting/admin/index')
      },
      {
        path: '/system/log/index',
        name: 'system_log_index',
        meta: {
          title: '日志管理',
          auth: true
        },
        component: () => import('@/components/system/setting/log/index')
      },
      {
        path: '/system/sys/index',
        name: 'system_sys_index',
        meta: {
          title: '网站基本管理',
          auth: true
        },
        component: () => import('@/components/system/setting/sys/index')
      },
      {
        path: '/system/menu/sys',
        name: 'system_menu_sys',
        meta: {
          title: '菜单管理',
          auth: true
        },
        component: () => import('@/components/system/setting/menu/sys')
      },
      {
        path: '/system/news/cate',
        name: 'system_news_cate',
        meta: {
          title: '新闻分类',
          auth: true
        },
        component: () => import('@/components/system/news/cate.vue')
      },
      {
        path: '/system/news/index',
        name: 'system_news_index',
        meta: {
          title: '新闻列表',
          auth: true
        },
        component: () => import('@/components/system/news/index.vue')
      },
      {
        path: '/system/news/add/:id?',
        name: 'system_news_add',
        meta: {
          title: '添加新闻',
          auth: true
        },
        component: () => import('@/components/system/news/add.vue')
      },
      {
        path: '/system/question/index',
        name: 'system_question_index',
        meta: {
          title: '问卷调查',
          auth: true
        },
        component: () => import('@/components/system/question/index.vue')
      },
      {
        path: '/system/question/add',
        name: 'system_question_add',
        meta: {
          title: '问卷操作',
          auth: true
        },
        component: () => import('@/components/system/question/add.vue')
      },
      {
        path: '/system/seller/index',
        name: 'system_seller_index',
        meta: {
          title: '律师和团队',
          auth: true
        },
        component: () => import('@/components/system/seller/index.vue')
      },
      {
        path: '/system/enterprise/index',
        name: 'system_enterprise_index',
        meta: {
          title: '企业管理',
          auth: true
        },
        component: () => import('@/components/system/enterprise/index.vue')
      },
      {
        path: '/system/question/report',
        name: 'system_question_report',
        meta: {
          title: '合规体检报告 ',
          auth: true
        },
        component: () => import('@/components/system/question/report.vue')
      },
      {
        path: '/system/question/reportv1_total',
        name: 'system_question_reportv1_total',
        meta: {
          title: '统计',
          auth: true
        },
        component: () => import('@/components/system/question/report_total.vue')
      },
      {
        path: '/system/question/total',
        name: 'system_question_total',
        meta: {
          title: '法制体检报告',
          auth: true
        },
        component: () => import('@/components/system/question/total.vue')
      },




      {
        path: '/system/small/questOne',
        name: 'system_small_questOne',
        meta: {
          title: '中小企业法律体检',
          auth: true
        },
        component: () => import('@/components/system/small/questOne.vue')
      },
      {
        path: '/system/small/questTwo',
        name: 'system_small_questTwo',
        meta: {
          title: '企业税务合规体检',
          auth: true
        },
        component: () => import('@/components/system/small/questTwo.vue')
      },
      {
        path: '/system/small/questThree',
        name: 'system_small_questThree',
        meta: {
          title: '企业人力资源全流程合规',
          auth: true
        },
        component: () => import('@/components/system/small/questThree.vue')
      },

      {
        path: '/system/small/report',
        name: 'system_small_report',
        meta: {
          title: '数据报告',
          auth: true
        },
        component: () => import('@/components/system/small/report.vue')
      },
      {
        path: '/system/small/link',
        name: 'system_small_link',
        meta: {
          title: '链接生成',
          auth: true
        },
        component: () => import('@/components/system/small/link.vue')
      }







    ]
  },
  {
    path: '/system/login',
    name: 'system_login',
    meta: {
      title: '总用户登录'
    },
    component: () => import('@/components/system/login/index')
  },
  {
    path: '/system/login2',
    name: 'system_login2',
    meta: {
      title: '总用户登录'
    },
    component: () => import('@/components/system/login/index2')
  }

]

/**
 * 错误页面
 */

const errorPage = [
  {
    path: '/system/*',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/components/system/error/404')
  }
]

export const systemInRoutes = system

// 重新组织后导出
export default [
  ...home,
  ...system,
  ...errorPage
]



// WEBPACK FOOTER //
// ./src/router/routes.js